/**
 * @module nhcmap/main
 */
import MapManager from '../shared/nhcmap/MapManager.js';
import './style.css';

/**
 * @description
 * This application is a generalized map designed to import a configuration
 * file and create a map with layers, controls, and overlays based on the
 * configuration.
 */
const products = [
  { id: 'wwCone', name: 'Experimental Cone', checked: true }
];
const lang = window.NHCMAP_GLOBAL.language || 'en';
// Parameters for the map manager
const params = {
  displayDropdown: false,
  autoZoom: true,
  latOffset: 1.0, // Offset to shift the map view down by 2 degrees
  lonOffset: 0.0,
  language: lang
};

// This is the main entry point for the application.
// We wait for the browser to signal that the HTML document is ready.
document.addEventListener('DOMContentLoaded', () => {
  // Wrap the async logic in an immediately invoked async function
  (async function initializeMap() {
    try {
      const mapManager = await MapManager.create(products, params);
    } catch (error) {
      console.error('Error initializing the map:', error);
    }
  })();
});